import { ChangeDetectionStrategy, Component } from "@angular/core";
import { CustomModal } from "@modules/core/components/base-modals";

@Component({
	selector: "app-deposit-expired",
	templateUrl: "./deposit-expired.component.html",
	styleUrls: ["../deposit-common-end-screen/deposit-common-end-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DepositExpiredComponent extends CustomModal {
	public failedIco: string = "/assets/images/failed.svg";
	public failedIcoAltI18nKey: string = "expired_deposit_icon_alt_text";

	constructor() {
		super();
	}

	public tryAgain(): void {
		this.modalService.popAll();
	}
}
